import { createGetterBS, createSetterBS } from '@ocodelib/ex-util/rx';
import { BehaviorSubject } from 'rxjs';
import type { IAppConfig, IJsBasicLayoutConfig, JsBasicAppType } from './types';
import { UiState } from './UiState';

export class JsBasicAppManager {
  private app$ = new BehaviorSubject<JsBasicAppType | null>(null);
  readonly uiState = new UiState();

  constructor(readonly appConfig: IAppConfig) {
    // empty
  }

  setApp = createSetterBS(this.app$);
  observeApp = createGetterBS(this.app$);

  setup(config: IJsBasicLayoutConfig) {
    this.uiState.updateFromConfig(config);
    if (this.appConfig.previewMode) {
      this.uiState.setPreviewMode(true);
    }
  }
}
